<template>
    <div>
        <div class="banner w-full absolute flex justify-start h-6 top-0">
            <template v-if="validBadge">
                <div
                    class="pl-2 pr-1 text-lg font-semibold leading-[22px] pt-0.5 text-white rounded-tl-md"
                    :class="validBadge.color === 'green' ? 'bg-new' : 'bg-sale'"
                >
                    {{ validBadge.translated.text }}
                </div>

                <MiscIcon
                    class="h-full -ml-0.5"
                    :class="validBadge.color === 'green' ? 'text-new' : 'text-sale'"
                    name="bannerend"
                />
            </template>

            <template v-else-if="data.customFields?.custom_product_additional_information_banner_text != null">
                <div
                    class="pl-2 pr-1 rounded-tl-lg text-lg font-semibold leading-[22px] pt-0.5"
                    :class="{
                        'bg-new text-white': data.customFields?.custom_product_additional_information_banner_color === 'product_listing_banner_color_green',
                        'bg-sale text-white': data.customFields?.custom_product_additional_information_banner_color === 'product_listing_banner_color_red',
                        'bg-star text-new': data.customFields?.custom_product_additional_information_banner_color == 'product_listing_banner_color_yellow'
                    }"
                >
                    {{ data.customFields?.custom_product_additional_information_banner_text }}
                </div>

                <MiscIcon
                    class="h-full -ml-0.5"
                    :class="{
                        'text-new': data.customFields?.custom_product_additional_information_banner_color === 'product_listing_banner_color_green',
                        'text-sale': data.customFields?.custom_product_additional_information_banner_color === 'product_listing_banner_color_red',
                        'text-star': data.customFields?.custom_product_additional_information_banner_color == 'product_listing_banner_color_yellow'
                    }"
                    name="bannerend"
                />
            </template>

        </div>
    </div>
</template>

<script setup lang="ts">
import {computed, ref} from "vue";

const props = defineProps<{
    data: any
}>()
const now = ref(new Date());

const validBadge = computed(() => {
    return props.data?.productFlags?.flags?.find(flag => {
        const startDate = new Date(flag.startDate);
        const endDate = new Date(flag.endDate);
        return startDate <= now.value && endDate > now.value;
    });
});
</script>